
import { defineComponent } from 'vue';
import FooterNav from './FooterNav.vue';

export default defineComponent({
  name: 'Footer',
  components: {
    FooterNav
  },
  computed: {
    getCurrentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    goToOfficalSite() {
      window.open('http://www.nanjunauto.com/');
    }
  }
});
